import { withReferrer } from 'utils/referrer';

// Map Query's referrer: the document page's root breadcrumb returns here. The
// TitleWorkspaceReferrer chip ignores it, matching only /title_workspaces paths.
export const MAP_QUERY_REFERRER = '/map-query';

// Map Query's document links only ever originate from its Documents tab. Tag the
// tab so the breadcrumb can return to it — the active tab is an in-memory atom
// that resets to Wells on a fresh page load (documents open in a new browser tab).
const MAP_QUERY_DOCUMENTS_DATASET = 'documents';

/**
 * Tags a document link to return to Map Query's Documents tab.
 * @param {string} href The document link.
 * @return {string} The tagged link.
 */
export function withMapQueryReferrer(href: string): string {
  return `${withReferrer(href, MAP_QUERY_REFERRER)}&dataset=${MAP_QUERY_DOCUMENTS_DATASET}`;
}
